import PhoneInputsForm from './PhoneInputsForm';

export default PhoneInputsForm;
